import { axiosInstance } from '../utils/axiosinstance';

export interface Event {
  _id: string;
  hackathonId: string;
  title: string;
  description: string;
  eventType: 'physical' | 'virtual';
  date: string; // DD/MM/YYYY
  time: string; // HH:MM AM/PM
  eventLink?: string;
  image?: string;
  createdAt: string;
  updatedAt: string;
}

export interface EventResponse {
  success: boolean;
  message?: string;
  data?: Event;
}

export interface EventsResponse {
  success: boolean;
  message?: string;
  data: Event[];
  count?: number;
}

export interface CreateEventRequest {
  hackathonId: string;
  title: string;
  description: string;
  eventType: 'physical' | 'virtual';
  date: string;
  time: string;
  eventLink?: string;
  image?: string;
}

export interface UpdateEventRequest {
  title?: string;
  description?: string;
  eventType?: 'physical' | 'virtual';
  date?: string;
  time?: string;
  eventLink?: string;
  image?: string;
}

export const eventApi = {
  // GET /events/hackathon/{hackathonId} - Get all events for a specific hackathon
  getEvents: async (hackathonId: string): Promise<EventsResponse> => {
    const token = localStorage.getItem('adminToken');
    const response = await axiosInstance.get(`/api/v1/events/hackathon/${hackathonId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },

  // GET /events/{id} - Get single event by ID
  getEventById: async (id: string): Promise<EventResponse> => {
    const token = localStorage.getItem('adminToken');
    const response = await axiosInstance.get(`/api/v1/events/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },

  // POST /events - Create new event
  createEvent: async (data: CreateEventRequest): Promise<EventResponse> => {
    const token = localStorage.getItem('adminToken');
    const response = await axiosInstance.post('/api/v1/events', data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },

  // PUT /events/{id} - Update event
  updateEvent: async (id: string, data: UpdateEventRequest): Promise<EventResponse> => {
    const token = localStorage.getItem('adminToken');
    const response = await axiosInstance.put(`/api/v1/events/${id}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },

  // DELETE /events/{id} - Delete event
  deleteEvent: async (id: string): Promise<EventResponse> => {
    const token = localStorage.getItem('adminToken');
    const response = await axiosInstance.delete(`/api/v1/events/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },
};
